/**
 * https://stackoverflow.com/a/50344705
 * Comando: ng build --configuration=prod
 * Comando: ng build --configuration=prod --output-hashing=all (para problemas con la cache)
 * Contexto para desplegar en el entorno de producción
 */
export const environment = {
  production: true,
  configuration: "prod",
  base_href: "",
  server_api_url: "https://wscarpeta.reus.cat/CarpetaV2Server/", //carpeta.reus.cat
  valid_url: "https://serveis.reus.cat/valid/",
  web_base_url: "https://carpeta.reus.cat", //carpeta.reus.cat
  //web_base_url: "https://carpetatestprod.reus.cat",//carpetatestprod.reus.cat
  delay: 0
};

// ######################################################################
// ##############             ¡¡¡ RECUERDA !!!             ##############

// Configura la penúltima línea del .htaccess de la raíz del proyecto:
// RewriteRule ^ /
// Y alójalo en la carpeta dist generada después de hacer el build

// ######################################################################
